/* Skapad av Claude Code — LP "Hundgodis paket" (svd-lp-hundgodis)
   Byggarlogik porterad från mockup v3.4; utseende/texter enligt Joels GodisboxV2 (2026-10-06).
   Priser i öre (variant.price).
   ATC: /cart/add.js med properties._godispaket → SVD Paket-motorn rabatterar.
   2026-09-23 (mallstyrda paketpickers): stämpelns värde = cfg.stamp = mallnamnet för
   LP:ns paketregel (sektionen räknar fram den ur produkternas egna mallar). Bara
   paketvaror (kort utan data-nodisc) stämplas. cfg.plain = ingen aktiv regel →
   ingen trappa, ingen reservtrappa, ingen stämpel (alla kort är då nodisc). */
(function () {
  'use strict';

  var root = document.querySelector('[data-hg-lp]');
  if (!root) return;

  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-hg-config]').textContent); } catch (e) { cfg = {}; }
  // Ingen hårdkodad reservtrappa (2026-09-23): utan trappa från en aktiv regel = enkelt läge.
  var TIERS = (cfg.tiers || []).slice().sort(function (a, b) { return a.min - b.min; });
  var PLAIN = cfg.plain === true || !TIERS.length;
  var STAMP = PLAIN ? '' : (cfg.stamp || ''); // mallnamnet för LP:ns regel; tomt = ingen stämpel
  var FS = typeof cfg.fs === 'number' ? cfg.fs : 59900; // öre; 0 = marknaden har ingen fri frakt
  var TXT = cfg.txt || {};
  var CUR = cfg.cur || {}; // symbol/placering/decimaler ur marknadens money-format
  var FILTERS = cfg.filters || [];
  var MAXPCT = TIERS.length ? (TIERS[TIERS.length - 1] || { pct: 0 }).pct : 20;

  var reduceMotion = (typeof matchMedia === 'function') && matchMedia('(prefers-reduced-motion: reduce)').matches;

  // state: key = variant-id (sträng) -> {qty, price(öre), title, variantTitle, img}
  var state = {};

  function kr(ore) {
    var dec = CUR.dec || 0, sym = CUR.sym || 'kr', loc = CUR.loc || 'sv-SE';
    var v = ore / 100;
    var n = (dec ? v : Math.round(v)).toLocaleString(loc, { minimumFractionDigits: dec, maximumFractionDigits: dec });
    return CUR.pre ? sym + n : n + ' ' + sym;
  }
  // Mobilbaren: lång text om den ryms på en rad, annars den korta (raderna är nowrap i CSS:en)
  function fit(el, long, short) {
    el.textContent = long;
    if (short && short !== long && el.clientWidth && el.scrollWidth > el.clientWidth + 1) el.textContent = short;
  }
  function t(key, fallback, vars) {
    var s = TXT[key] || fallback;
    if (vars) Object.keys(vars).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); });
    return s;
  }

  /* ---- kortens aktiva variant ---- */
  function cardVariant(card) {
    var pressed = card.querySelector('.hg-vars [aria-pressed="true"]');
    var src = pressed || card;
    return {
      id: src.getAttribute('data-id'),
      price: parseInt(src.getAttribute('data-price'), 10) || 0,
      variantTitle: pressed ? pressed.getAttribute('data-vtitle') : ''
    };
  }

  function chg(vid, d, meta) {
    var st = state[vid];
    if (!st) {
      if (d <= 0) return;
      st = state[vid] = { qty: 0, price: meta.price, title: meta.title, variantTitle: meta.variantTitle, img: meta.img, nodisc: !!meta.nodisc };
    }
    st.qty = Math.max(0, st.qty + d);
    render();
  }

  /* ---- fly-to-pack ---- */
  function fly(card) {
    if (reduceMotion) return;
    var img = card.querySelector('.hg-img img');
    if (!img) return;
    var from = img.getBoundingClientRect();
    var targetEl = window.innerWidth <= 860 ? root.querySelector('.hg-thumbs') : root.querySelector('.hg-panel-col .hg-panel-head');
    if (!targetEl) return;
    var to = targetEl.getBoundingClientRect();
    var f = img.cloneNode();
    f.className = 'hg-fly';
    f.style.left = (from.left + from.width / 2 - 32) + 'px';
    f.style.top = (from.top + from.height / 2 - 37) + 'px';
    document.body.appendChild(f);
    requestAnimationFrame(function () {
      var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
      var dy = (to.top + to.height / 2) - (from.top + from.height / 2);
      f.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.25)';
      f.style.opacity = '0.2';
    });
    setTimeout(function () { f.remove(); }, 600);
  }

  /* ---- konfetti ---- */
  var cv = root.querySelector('.hg-confetti');
  var cx = null;
  try { cx = cv.getContext('2d'); } catch (e) { cx = null; }
  var parts = [], raf = null;
  function confetti(x, y) {
    if (reduceMotion || !cx) return;
    cv.width = window.innerWidth; cv.height = window.innerHeight;
    var cols = ['#2F7D54', '#4FA06C', '#F0B368', '#E08A3C', '#283455', '#FBD116'];
    for (var i = 0; i < 48; i++) {
      parts.push({ x: x, y: y, vx: (Math.random() - .5) * 9, vy: -Math.random() * 8 - 3, g: .32, s: 4 + Math.random() * 4, c: cols[i % cols.length], r: Math.random() * Math.PI, vr: (Math.random() - .5) * .3, life: 60 + Math.random() * 20 });
    }
    if (!raf) tick();
  }
  function tick() {
    cx.clearRect(0, 0, cv.width, cv.height);
    parts = parts.filter(function (p) { return p.life > 0; });
    parts.forEach(function (p) {
      p.x += p.vx; p.y += p.vy; p.vy += p.g; p.r += p.vr; p.life--;
      cx.save(); cx.translate(p.x, p.y); cx.rotate(p.r);
      cx.globalAlpha = Math.min(1, p.life / 25); cx.fillStyle = p.c;
      cx.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * .6); cx.restore();
    });
    raf = parts.length ? requestAnimationFrame(tick) : null;
    if (!parts.length) cx.clearRect(0, 0, cv.width, cv.height);
  }

  /* ---- summering ----
     Kort med data-nodisc (produkter vars egen mall inte hör till LP:ns paketregel)
     räknas INTE i rabattrappan och stämplas inte — motorn rabatterar dem ändå
     aldrig. De ingår i totalen till ordinarie pris. ---- */
  function totals() {
    var bags = 0, ord = 0, extras = 0, items = 0;
    Object.keys(state).forEach(function (k) {
      var st = state[k];
      if (!st.qty) return;
      items += st.qty;
      if (st.nodisc) { extras += st.price * st.qty; return; }
      bags += st.qty; ord += st.price * st.qty;
    });
    var pct = 0;
    TIERS.forEach(function (tr) { if (bags >= tr.min) pct = tr.pct; });
    return { bags: bags, ord: ord, extras: extras, items: items, pct: pct, disc: ord * pct / 100, total: ord * (1 - pct / 100) + extras };
  }
  function nextTier(bags) {
    // Hoppa över steg som inte höjer procenten (t.ex. dolt 3-steg när 4-steget har samma %)
    var pct = 0;
    TIERS.forEach(function (tr) { if (bags >= tr.min) pct = tr.pct; });
    for (var i = 0; i < TIERS.length; i++) if (bags < TIERS[i].min && TIERS[i].pct > pct) return TIERS[i];
    return null;
  }

  var lastPct = 0;
  function render() {
    var tt2 = totals();
    if (tt2.pct > lastPct) {
      var src = window.innerWidth <= 860 ? root.querySelector('.hg-mbar') : root.querySelector('.hg-panel-col .hg-ladder');
      var r = src ? src.getBoundingClientRect() : { left: window.innerWidth / 2, top: window.innerHeight / 2, width: 0 };
      confetti(r.left + r.width / 2, r.top + 10);
      toast(t('unlock', '{pct} % rabatt upplåst — bra jobbat!', { pct: tt2.pct }));
      root.querySelectorAll('.hg-cell.hg-reached:last-of-type').forEach(function (c) {
        c.classList.remove('hg-pop'); void c.offsetWidth; c.classList.add('hg-pop');
      });
    }
    lastPct = tt2.pct;

    // kort
    root.querySelectorAll('.hg-card').forEach(function (el) {
      var v = cardVariant(el);
      var q = 0;
      // summera alla varianter som hör till kortet
      el.querySelectorAll('.hg-vars [data-id]').forEach(function (b) {
        var st = state[b.getAttribute('data-id')];
        if (st) q += st.qty;
      });
      if (!el.querySelector('.hg-vars')) {
        var st1 = state[v.id];
        q = st1 ? st1.qty : 0;
      }
      el.classList.toggle('hg-in-pack', q > 0);
      var dot = el.querySelector('.hg-qty-dot');
      if (dot) {
        var txt = q + ' st';
        if (dot.textContent !== txt && q > 0) { dot.classList.remove('hg-pop'); void dot.offsetWidth; dot.classList.add('hg-pop'); }
        dot.textContent = txt;
      }
      var qEl = el.querySelector('.hg-stepper .hg-q');
      if (qEl) qEl.textContent = TXT.v2_box ? (q || 1) + ' ' + TXT.v2_box : t('in_box', '{n} i boxen', { n: q || 1 });
    });

    // trapprutorna i toppen (nådd = grön, nästa = streckad — först när något ligger i paketet)
    var nxTop = nextTier(tt2.bags);
    root.querySelectorAll('.hg2-tier').forEach(function (c) {
      c.classList.toggle('hg-reached', tt2.bags >= parseInt(c.getAttribute('data-min'), 10));
      c.classList.toggle('hg-next', !!nxTop && tt2.bags > 0 && parseInt(c.getAttribute('data-pct'), 10) === nxTop.pct);
    });

    // paneler (desktop + mobil-sheet)
    root.querySelectorAll('.hg-panel').forEach(function (pa) {
      var nx = nextTier(tt2.bags);
      pa.querySelectorAll('.hg-cell').forEach(function (c) {
        var m = parseInt(c.getAttribute('data-min'), 10);
        c.classList.toggle('hg-reached', tt2.bags >= m);
        // Matcha på procent så markeringen träffar det SYNLIGA steget även när ett dublett-steg är dolt
        var cp = parseInt(c.getAttribute('data-pct'), 10);
        c.classList.toggle('hg-next', !!nx && cp === nx.pct && tt2.bags > 0);
      });
      var nd = pa.querySelector('[data-role="nudge"]');
      if (!tt2.bags) nd.innerHTML = '';
      else if (nx) nd.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="8" cy="8" r="6.2"/><path d="M8 5.2v5.6M5.2 8h5.6"/></svg> ' + t('nudge', 'Lägg till {n} till — lås upp {pct} % rabatt', { n: nx.min - tt2.bags, pct: nx.pct });
      else nd.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M2.5 8.5l3.5 3.5 7.5-8"/></svg> ' + t('maxed', 'Högsta rabatten upplåst — {pct} % på allt!', { pct: (TIERS[TIERS.length - 1] || { pct: 0 }).pct });

      pa.querySelector('[data-role="empty"]').style.display = tt2.items ? 'none' : '';

      var ln = pa.querySelector('[data-role="lines"]');
      ln.innerHTML = '';
      Object.keys(state).forEach(function (vid) {
        var st = state[vid];
        if (!st.qty) return;
        var lp = st.price * st.qty;
        var row = document.createElement('div');
        row.className = 'hg-line';
        row.innerHTML = '<img src="' + st.img + '" alt="">' +
          '<div class="hg-li-mid"><div class="hg-li-name"></div>' + (st.variantTitle ? '<div class="hg-li-var"></div>' : '') + '</div>' +
          '<div class="hg-li-qty"><button type="button" data-d="-1" aria-label="' + t('fewer', 'Färre') + '">−</button><span>' + st.qty + '</span><button type="button" data-d="1" aria-label="' + t('more', 'Fler') + '">+</button></div>' +
          '<div class="hg-li-price">' + (tt2.pct && !st.nodisc ? '<span class="hg-was">' + kr(lp) + '</span><span class="hg-now hg-saved">' + kr(lp * (1 - tt2.pct / 100)) + '</span>' : '<span class="hg-now">' + kr(lp) + '</span>') + '</div>';
        row.querySelector('.hg-li-name').textContent = st.title;
        if (st.variantTitle) row.querySelector('.hg-li-var').textContent = st.variantTitle;
        row.querySelectorAll('.hg-li-qty button').forEach(function (b) {
          b.addEventListener('click', function () { chg(vid, parseInt(b.getAttribute('data-d'), 10)); });
        });
        ln.appendChild(row);
      });

      var sums = pa.querySelector('[data-role="sums"]');
      sums.hidden = !tt2.items;
      if (tt2.items) {
        pa.querySelector('[data-role="sum-ord"]').textContent = kr(tt2.ord + tt2.extras);
        pa.querySelector('[data-role="row-disc"]').style.display = tt2.pct ? '' : 'none';
        pa.querySelector('[data-role="disc-pct"]').textContent = '−' + tt2.pct + ' %';
        pa.querySelector('[data-role="sum-disc"]').textContent = '−' + kr(tt2.disc);
        pa.querySelector('[data-role="sum-total"]').textContent = kr(tt2.total);
        var chip = pa.querySelector('[data-role="chip"]');
        chip.hidden = !tt2.pct;
        if (tt2.pct) chip.textContent = t('saving', 'Du sparar {kr} på det här paketet', { kr: kr(tt2.disc) });
        var shipEl = pa.querySelector('.hg-ship');
        if (FS > 0) {
          if (shipEl) shipEl.hidden = false;
          pa.querySelector('[data-role="ship-txt"]').innerHTML = tt2.total >= FS ? '<b>' + t('fs_done', '✓ Fri frakt upplåst!') + '</b>' : t('fs_left', '{kr} kvar till', { kr: kr(FS - tt2.total) }) + ' <b>' + t('fs_word', 'fri frakt') + '</b>';
          pa.querySelector('[data-role="ship-fill"]').style.width = Math.min(100, tt2.total / FS * 100) + '%';
        } else if (shipEl) {
          shipEl.hidden = true;
        }
      }
      var atc = pa.querySelector('[data-role="atc"]');
      atc.disabled = !tt2.items;
      atc.textContent = tt2.items ? t('atc', 'Lägg paketet i varukorgen') + ' · ' + kr(tt2.total) : t('atc_empty', 'Välj minst 1 godis');
    });

    // mobilbar
    var th = root.querySelector('.hg-thumbs');
    th.innerHTML = '';
    var chosen = Object.keys(state).filter(function (k) { return state[k].qty > 0; });
    if (!chosen.length) {
      for (var i = 0; i < 3; i++) { var d0 = document.createElement('span'); d0.className = 'hg-th hg-emptyslot'; th.appendChild(d0); }
    } else {
      // högst tre platser som designen (två bilder + "+N" när fler än tre)
      var nThumbs = chosen.length > 3 ? 2 : 3;
      chosen.slice(0, nThumbs).forEach(function (k) {
        var d1 = document.createElement('span'); d1.className = 'hg-th';
        d1.style.backgroundImage = 'url(' + state[k].img + ')'; th.appendChild(d1);
      });
      if (chosen.length > 3) { var d2 = document.createElement('span'); d2.className = 'hg-th hg-morecnt'; d2.textContent = '+' + (chosen.length - nThumbs); th.appendChild(d2); }
      var last = th.lastChild; last.classList.remove('hg-pop'); void last.offsetWidth; last.classList.add('hg-pop');
    }
    var bagWord = tt2.bags === 1 ? t('bag', 'produkt') : t('bags', 'produkter');
    var tail = tt2.pct ? t('pct_off', '{pct} % rabatt', { pct: tt2.pct }) : kr(tt2.total);
    fit(root.querySelector('[data-role="mbar-l1"]'),
      tt2.bags ? tt2.bags + ' ' + bagWord + ' · ' + tail : (tt2.items ? tt2.items + ' ' + t('items', 'varor') + ' · ' + kr(tt2.total) : t('mbar_empty', 'Ditt paket är tomt')),
      tt2.bags ? tt2.bags + ' ' + t('pcs', 'st') + ' · ' + tail : (tt2.items ? tt2.items + ' ' + t('pcs', 'st') + ' · ' + kr(tt2.total) : t('mbar_empty', 'Ditt paket är tomt')));
    var l2 = root.querySelector('[data-role="mbar-l2"]');
    var nx2 = nextTier(tt2.bags);
    if (!tt2.bags) { l2.className = 'hg-l2 hg-idle'; l2.textContent = PLAIN ? '' : t('mbar_idle', '3 påsar = 10 % rabatt'); }
    else if (nx2) { l2.className = 'hg-l2'; l2.textContent = t('more_to', '{n} till = {pct} % rabatt', { n: nx2.min - tt2.bags, pct: nx2.pct }); }
    else { l2.className = 'hg-l2'; fit(l2, t('maxed_plain', 'Högsta rabatten upplåst'), t('maxed_short', 'Maxrabatt upplåst')); }
    var maxMin = TIERS.length ? TIERS[TIERS.length - 1].min : 1;
    root.querySelector('[data-role="mprog"]').style.width = Math.min(1, tt2.bags / maxMin) * 100 + '%';
    var plabel = root.querySelector('[data-role="mprogl"]');
    plabel.hidden = !tt2.pct;
    if (tt2.pct) plabel.textContent = '−' + tt2.pct + ' %';
    var mat = root.querySelector('[data-role="mbar-atc"]');
    mat.disabled = !tt2.items;
    mat.textContent = tt2.items ? t('v2_cta', 'Till kassan') : t('mbar_pick', 'Välj godis');
    // med varor i paketet ska baren alltid synas, oavsett scrolläge
    root.classList.toggle('hg-has-items', tt2.items > 0);
  }

  /* ---- variantpopup: "Välj storlek/smak" för kort med flera varianter ---- */
  var vp = null;
  function buildVarPick() {
    if (vp) return;
    var bg = document.createElement('div'); bg.className = 'hg-vp-bg';
    var el = document.createElement('div');
    el.className = 'hg-varpick'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true');
    el.innerHTML = '<button type="button" class="hg-vp-close" aria-label="' + t('close', 'Stäng') + '"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M3.5 3.5l9 9M12.5 3.5l-9 9"/></svg></button>' +
      '<h3 class="hg-vp-title"></h3><div class="hg-vp-prod"></div><div class="hg-vp-list"></div>';
    document.body.appendChild(bg); document.body.appendChild(el);
    bg.addEventListener('click', closeVarPick);
    el.querySelector('.hg-vp-close').addEventListener('click', closeVarPick);
    vp = { bg: bg, el: el };
  }
  function closeVarPick() { document.body.classList.remove('hg-vp-open'); }
  function openVarPick(card, meta) {
    var chips = card.querySelectorAll('.hg-vars [data-id]');
    if (!chips.length) return false;
    buildVarPick();
    var wrap = card.querySelector('.hg-vars');
    var optname = (wrap.getAttribute('data-optname') || '').trim();
    vp.el.querySelector('.hg-vp-title').textContent = optname && optname.toLowerCase() !== 'title' ? t('vp_pick', 'Välj {name}', { name: optname.toLowerCase() }) : t('vp_variant', 'Välj variant');
    vp.el.querySelector('.hg-vp-prod').textContent = card.getAttribute('data-title') || '';
    var list = vp.el.querySelector('.hg-vp-list');
    list.innerHTML = '';
    chips.forEach(function (ch) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'hg-vp-opt';
      var lbl = document.createElement('span'); lbl.textContent = ch.getAttribute('data-vtitle') || ch.textContent;
      var pr = document.createElement('b'); pr.textContent = kr(parseInt(ch.getAttribute('data-price'), 10) || 0);
      b.appendChild(lbl); b.appendChild(pr);
      b.addEventListener('click', function () {
        ch.click();
        var v = cardVariant(card);
        chg(v.id, 1, meta());
        fly(card);
        closeVarPick();
      });
      list.appendChild(b);
    });
    document.body.classList.add('hg-vp-open');
    return true;
  }

  /* ---- toast ---- */
  var toastEl = root.querySelector('.hg-toast'), toastTimer;
  function toast(msg, kind) {
    toastEl.textContent = msg;
    toastEl.classList.toggle('hg-info', kind === 'info');
    toastEl.classList.toggle('hg-error', kind === 'error');
    toastEl.classList.add('hg-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('hg-show'); }, 3200);
  }

  /* ---- ATC: alla rader med _godispaket i ETT anrop ---- */
  var atcBusy = false;
  function addAllToCart() {
    if (atcBusy) return;
    var items = [];
    Object.keys(state).forEach(function (vid) {
      var st = state[vid];
      if (!st.qty) return;
      var line = { id: parseInt(vid, 10), quantity: st.qty };
      if (!st.nodisc && STAMP) line.properties = { _godispaket: STAMP };
      items.push(line);
    });
    if (!items.length) return;
    atcBusy = true;
    root.querySelectorAll('[data-role="atc"]').forEach(function (b) { b.disabled = true; b.textContent = t('atc_busy', 'Lägger i varukorgen …'); });
    var mb = root.querySelector('[data-role="mbar-atc"]'); mb.disabled = true; mb.textContent = t('atc_busy', 'Lägger i varukorgen …');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || t('cart_error', 'Kunde inte lägga i varukorgen')); });
      window.location.href = '/cart';
    }).catch(function (err) {
      atcBusy = false;
      toast(err.message || t('atc_error', 'Något gick fel — försök igen'), 'error');
      render();
    });
  }

  /* ---- init: kort ---- */
  root.querySelectorAll('.hg-card').forEach(function (card) {
    var meta = function () {
      var v = cardVariant(card);
      return {
        price: v.price,
        variantTitle: v.variantTitle,
        title: card.getAttribute('data-title'),
        img: card.getAttribute('data-img'),
        nodisc: card.hasAttribute('data-nodisc')
      };
    };
    var moreBtn = card.querySelector('.hg-more-btn');
    if (moreBtn) moreBtn.addEventListener('click', function () {
      var open = card.classList.toggle('hg-open');
      moreBtn.setAttribute('aria-expanded', open);
    });
    var addBtn = card.querySelector('.hg-add');
    if (addBtn) addBtn.addEventListener('click', function () {
      if (card.querySelector('.hg-vars') && openVarPick(card, meta)) return;
      var v = cardVariant(card);
      chg(v.id, 1, meta());
      fly(card);
    });
    card.querySelectorAll('.hg-stepper button').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = parseInt(b.getAttribute('data-d'), 10);
        var v = cardVariant(card);
        // minska: dra från senaste variant med qty; öka: aktiv variant
        if (d < 0) {
          var pool = card.querySelector('.hg-vars') ?
            Array.prototype.map.call(card.querySelectorAll('.hg-vars [data-id]'), function (x) { return x.getAttribute('data-id'); }) : [v.id];
          for (var i = pool.length - 1; i >= 0; i--) {
            if (state[pool[i]] && state[pool[i]].qty > 0) { chg(pool[i], -1); return; }
          }
          return;
        }
        if (card.querySelector('.hg-vars') && openVarPick(card, meta)) return;
        chg(v.id, 1, meta());
        fly(card);
      });
    });
    card.querySelectorAll('.hg-vars [data-id]').forEach(function (b) {
      b.addEventListener('click', function () {
        card.querySelectorAll('.hg-vars [data-id]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        var vPrice = parseInt(b.getAttribute('data-price'), 10);
        var priceEl = card.querySelector('[data-role="cprice"]');
        if (priceEl) priceEl.textContent = kr(vPrice);
        var paketEl = card.querySelector('[data-role="cpaket"]');
        if (paketEl) paketEl.textContent = (TXT.paket || 'Från [pris]/st i paket').replace('[pris]', kr(vPrice * (1 - MAXPCT / 100)));
        render();
      });
    });
  });

  root.querySelectorAll('[data-role="atc"]').forEach(function (b) { b.addEventListener('click', addAllToCart); });

  /* ---- mobil-sheet: öppna/stäng (kryss, bakgrund, Escape) ---- */
  function openSheet() { document.body.classList.add('hg-sheet-open'); }
  function closeSheet() { document.body.classList.remove('hg-sheet-open'); }
  root.querySelector('[data-role="mbar-open"]').addEventListener('click', openSheet);
  // mobilbarens knapp lägger paketet direkt i varukorgen (samma addAllToCart); vänstra delen öppnar bladet
  root.querySelector('[data-role="mbar-atc"]').addEventListener('click', addAllToCart);
  root.querySelector('.hg-sheet-bg').addEventListener('click', closeSheet);
  var sheetClose = root.querySelector('[data-role="sheet-close"]');
  if (sheetClose) sheetClose.addEventListener('click', closeSheet);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (document.body.classList.contains('hg-vp-open')) { closeVarPick(); return; }
    if (document.body.classList.contains('hg-sheet-open')) closeSheet();
  });

  /* ---- kategorifilter: RIKTIGA filter (inte scrollspy). "Alla" visar allt i
     kollektionens ordning; ett gruppklick döljer alla kort som inte hör till gruppen
     (data-fg innehåller |gN|) och SORTERAR OM de synliga: blockets "Högst upp"-lista
     först (pin), därefter bästsäljarna i Smart-rankingordning (om Smart är på),
     sist övriga i grundordning. "Alla" återställer grundordningen. Ingen scroll. ---- */
  (function initFilter() {
    var nav = root.querySelector('[data-role="filter"]');
    if (!nav) return;
    var grid = root.querySelector('[data-role="grid"]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-role="grid"] .hg-card'));
    var origOrder = cards.slice();
    var byHandle = {};
    cards.forEach(function (c) { byHandle[c.getAttribute('data-handle')] = c; });
    var cnt = root.querySelector('[data-role="cnt"]');
    function setCount(n) { if (cnt) cnt.textContent = n + ' ' + t('v2_count', 'produkter'); }
    setCount(cards.length);
    // bara filter som faktiskt fick kort blir knappar
    var usable = FILTERS.filter(function (f) {
      return cards.some(function (c) { return (c.getAttribute('data-fg') || '').indexOf('|' + f.key + '|') !== -1; });
    });
    if (usable.length < 2) return;
    // Designen: ingen Alla-knapp — startfiltret (inställningen "Startfilter", matchas på
    // knapptexten, annars första gruppen) ligger först och är valt från start.
    var want = (TXT.v2_start || '').trim().toLowerCase();
    var startDef = usable.filter(function (f) { return (f.label || '').trim().toLowerCase() === want; })[0] || usable[0];
    var defs = [startDef].concat(usable.filter(function (f) { return f !== startDef; }));
    var btns = defs.map(function (f) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = f.label;
      b.setAttribute('aria-current', String(f === startDef));
      b.addEventListener('click', function () { apply(f, b); });
      nav.appendChild(b);
      return b;
    });
    nav.hidden = false;
    function orderFor(f) {
      if (f.key === 'all') return origOrder;
      var seen = {};
      var out = [];
      function push(c) {
        if (!c) return;
        var h = c.getAttribute('data-handle');
        if (seen[h]) return;
        seen[h] = true;
        out.push(c);
      }
      (f.pin || []).forEach(function (h) { push(byHandle[h]); });
      if (f.smart) (cfg.smart_rank || []).forEach(function (h) { push(byHandle[h]); });
      origOrder.forEach(push);
      // paketvaror (rabatt) före fullprisvaror, inbördes ordning kvar — annars möts kunden
      // av t.ex. fästa tillskott till fullpris först i Bästsäljare på en godisbox-sida.
      out = out.filter(function (c) { return !c.hasAttribute('data-nodisc'); }).concat(out.filter(function (c) { return c.hasAttribute('data-nodisc'); }));
      return out;
    }
    function apply(f, activeBtn) {
      var shown = 0;
      cards.forEach(function (c) {
        var hit = f.key === 'all' || (c.getAttribute('data-fg') || '').indexOf('|' + f.key + '|') !== -1;
        c.classList.toggle('hg-hide', !hit);
        if (hit) shown++;
      });
      orderFor(f).forEach(function (c) { grid.appendChild(c); });
      btns.forEach(function (b) { b.setAttribute('aria-current', String(b === activeBtn)); });
      setCount(cards.length);
    }
    apply(startDef, btns[0]);
  })();

  /* ---- cookiebanner (Pandectes): lyft mobilbaren ovanför tills bannern stängs.
     Bannern bor i shadow DOM under <pandectes-cmp> — mät bottenförankrade element
     generiskt och sätt --hg-cookie-h på LP-roten. ---- */
  (function initCookieOffset() {
    var cmp = document.querySelector('pandectes-cmp');
    if (!cmp) return;
    function bannerH() {
      var els = [cmp];
      try {
        if (cmp.shadowRoot) els = els.concat(Array.prototype.slice.call(cmp.shadowRoot.querySelectorAll('div,section,footer')).slice(0, 120));
      } catch (e) { /* stängd shadow root — mät bara värden */ }
      for (var i = 0; i < els.length; i++) {
        var r = els[i].getBoundingClientRect();
        // bottenförankrad banner (inte centrerad modal): bred, når nederkanten,
        // börjar på nedre halvan av skärmen
        if (r.height > 60 && r.width > window.innerWidth * 0.6 && r.bottom > window.innerHeight - 24 && r.top > window.innerHeight * 0.45) {
          return Math.round(window.innerHeight - r.top);
        }
      }
      return 0;
    }
    var last = -1;
    function sync() {
      var h = bannerH();
      if (h !== last) { last = h; root.style.setProperty('--hg-cookie-h', h + 'px'); }
    }
    sync();
    setInterval(sync, 900);
    window.addEventListener('resize', sync);
  })();

  /* ---- mobilbaren: dold tills godis-blocken nåtts (sedan kvar även förbi dem) ---- */
  (function initMbarReveal() {
    var builder = root.querySelector('.hg-builder');
    if (!builder || !('IntersectionObserver' in window)) {
      root.classList.add('hg-mbar-show');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      var en = entries[0];
      // synlig när byggaren är i (eller ovanför) viewporten — döljs igen bara
      // om man scrollar tillbaka upp till hero:n
      root.classList.toggle('hg-mbar-show', en.isIntersecting || en.boundingClientRect.top < 0);
    }, { rootMargin: '0px 0px -55% 0px' });
    io.observe(builder);
  })();

  render();
})();
